import { ApolloProvider, useLazyQuery, useQuery } from '@apollo/client/react';
import { LayoutProvider, useLayoutContext } from '@assets/spa/context/layout';
import Layout from '@assets/spa/layout/main';
import React, { useEffect } from 'react';
import qPage from '@assets/gql/page.gql';
import { DebugBar } from '@assets/spa/debugBar';
import '@assets/scss/globals.scss';
// import '@fortawesome/fontawesome-free/css/all.min.css';
import { createRoutesFromElements, Outlet, Route, useLocation, } from "react-router-dom";
import { Page } from '@assets/spa/page';
import { getElementorPage } from '@assets/spa/layout/data';
import { LangProvider, useLangContext } from '@assets/spa/context/lang';
import { SplashScreen } from '@assets/spa/splashScreen';
import { ErrorScreen } from '@assets/spa/errorScreen';
import { ListProvider } from '@assets/spa/context/list';
import { Accessability } from '@assets/tsx/a11y/a11y';
import { A11yProvider } from '@assets/spa/context/a11y';
import qLangData from '@assets/gql/langData.gql';
import { I18nProvider, useI18n } from '@wordpress/react-i18n';
export const PageContent = () => {
    var _a, _b, _c, _d;
    const location = useLocation();
    const search = (new URLSearchParams(location.search)).get('s');
    const { data, loading, error, } = useQuery(qPage, {
        variables: { uri: location.pathname + `${search ? `?s=${search}` : ''}` },
    });
    const redirection = (_a = data === null || data === void 0 ? void 0 : data.nodeByUri) === null || _a === void 0 ? void 0 : _a.redirection;
    if (data && !!redirection && redirection.indexOf('/') !== 0) {
        const protocolRegex = /^(https?|ftp):\/\//i;
        let redirectUrl = redirection;
        if (!protocolRegex.test(redirectUrl)) {
            redirectUrl = `https://${redirectUrl}`;
        }
        typeof window !== 'undefined' && window.location.replace(redirectUrl);
        return React.createElement("div", { style: { padding: 16, minHeight: 300, display: 'flex', flexDirection: 'column', justifyContent: 'center' } },
            React.createElement("h2", { style: { textAlign: 'center' } },
                "Peradresavimas \u012F: \"",
                React.createElement("a", { href: redirectUrl }, redirectUrl),
                "\""));
    }
    const headerId = ((_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.nodeByUri) === null || _b === void 0 ? void 0 : _b.layout) === null || _c === void 0 ? void 0 : _c.header) === null || _d === void 0 ? void 0 : _d.id) || -1;
    return React.createElement(LayoutProvider, { headerId: headerId },
        React.createElement(Layout, null,
            React.createElement(InternalPage, Object.assign({}, { data, loading, error })),
            React.createElement(Accessability, null)));
};
const themeDocumentTitles = {
    'ltg': 'Lietuvos Geležinkeliai',
    'infra': 'LTG Infra',
    'cargo': 'LTG Cargo',
    'museum': 'Geležinkelių muziejus',
    'gtc': 'LTG GTC'
};
export function InternalPage({ data, loading, error }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const [lang, setLang, , setUrlTranslates] = useLangContext();
    const [getLangData, { data: langData }] = useLazyQuery(qLangData);
    const { __ } = useI18n();
    const location = useLocation();
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (!data)
            return;
        const title = [(_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.nodeByUri) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.body) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.title, themeDocumentTitles[THEME]].filter(s => !!s).join(' | ');
        document.title = title;
        const lang = (_j = (_h = (_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.nodeByUri) === null || _e === void 0 ? void 0 : _e.layout) === null || _f === void 0 ? void 0 : _f.body) === null || _g === void 0 ? void 0 : _g.meta) === null || _h === void 0 ? void 0 : _h.language) === null || _j === void 0 ? void 0 : _j.slug;
        !!lang && setLang(lang);
        const urlTranslatesData = (_k = data === null || data === void 0 ? void 0 : data.nodeByUri) === null || _k === void 0 ? void 0 : _k.languagePermalinks;
        if (urlTranslatesData === null || urlTranslatesData === void 0 ? void 0 : urlTranslatesData.length) {
            const urlTranslates = urlTranslatesData.reduce((agr, { language, permalink }) => (Object.assign(Object.assign({}, agr), { [language]: permalink })), {});
            setUrlTranslates(urlTranslates);
        }
        else {
            setUrlTranslates({});
        }
    }, [data]);
    // useEffect(()=>{
    // 	const trueUrl = data?.nodeByUri?.uri;
    // 	if(!trueUrl) return;
    // 	if(location.pathname !== trueUrl){
    // 		navigate(trueUrl,{replace:true});
    // 	}
    // },[location.pathname,data?.nodeByUri?.uri])
    useEffect(() => {
        if (!lang)
            return;
        let currentLang = wp.i18n.getLocaleData('ltg-widgets')[''].lang.substr(0, 2);
        if (currentLang === lang)
            return;
        getLangData({ variables: { lang } });
    }, [lang]);
    useEffect(() => {
        if (!langData)
            return;
        if (!(langData === null || langData === void 0 ? void 0 : langData.themeLocalizationData))
            return;
        const data = JSON.parse(langData === null || langData === void 0 ? void 0 : langData.themeLocalizationData);
        window.wp.i18n.resetLocaleData(data, 'ltg-widgets');
    }, [langData]);
    useEffect(() => {
        document.scrollingElement.scrollTop = 0;
    }, [location.pathname]);
    const headerId = ((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.nodeByUri) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.header) === null || _c === void 0 ? void 0 : _c.id) || -1;
    const footerId = ((_f = (_e = (_d = data === null || data === void 0 ? void 0 : data.nodeByUri) === null || _d === void 0 ? void 0 : _d.layout) === null || _e === void 0 ? void 0 : _e.footer) === null || _f === void 0 ? void 0 : _f.id) || -1;
    const bodyClass = ((_k = (_j = (_h = (_g = data === null || data === void 0 ? void 0 : data.nodeByUri) === null || _g === void 0 ? void 0 : _g.layout) === null || _h === void 0 ? void 0 : _h.body) === null || _j === void 0 ? void 0 : _j.bodyClass) === null || _k === void 0 ? void 0 : _k.join(' ')) || "";
    const [layout, setLayout] = useLayoutContext();
    useEffect(() => {
        if (loading)
            return;
        setLayout({ bodyClass, headerId, footerId });
    }, [bodyClass, headerId, footerId, loading]);
    if (error)
        return React.createElement(ErrorScreen, null);
    if ((data === null || data === void 0 ? void 0 : data.nodeByUri) === null || ((_m = (_l = data === null || data === void 0 ? void 0 : data.nodeByUri) === null || _l === void 0 ? void 0 : _l.layout) === null || _m === void 0 ? void 0 : _m.body) === null || ((_q = (_p = (_o = data === null || data === void 0 ? void 0 : data.nodeByUri) === null || _o === void 0 ? void 0 : _o.layout) === null || _p === void 0 ? void 0 : _p.body) === null || _q === void 0 ? void 0 : _q.elementorData) === null) {
        return React.createElement(ErrorScreen, { title: __('Puslapis nerastas', 'ltg-widgets'), message: __('404 | Puslapis šiuo adresu neegzistuoja', 'ltg-widgets') });
    }
    const templates = getElementorPage((_r = data === null || data === void 0 ? void 0 : data.nodeByUri) === null || _r === void 0 ? void 0 : _r.layout);
    if (loading)
        return React.createElement(SplashScreen, null);
    return React.createElement(Page, Object.assign({}, templates, { bodyClass: bodyClass }));
}
export const routes = createRoutesFromElements(React.createElement(Route, { element: React.createElement(ListProvider, null,
        React.createElement(A11yProvider, null,
            React.createElement(DebugBar, null),
            React.createElement(Outlet, null))) },
    React.createElement(Route, { path: '*', element: React.createElement(PageContent, null) })));
export function App({ i18n, children, client, lang }) {
    return React.createElement(ApolloProvider, { client: client },
        React.createElement(LangProvider, { currentLang: lang },
            React.createElement(I18nProvider, { i18n: i18n }, children)));
}
